import { BLUE_RIBBON_700, NEUTRAL_100, SKY_BLUE } from "@styles/colors";
import { GIVONIC } from "@styles/fonts";
import styled from "styled-components";

// Container component
export const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: ${SKY_BLUE};
    padding-bottom: 8vh;
`;

// Title component
export const Title = styled.span`
    font-family: ${GIVONIC.bold};
    color: ${BLUE_RIBBON_700};
    width: 50%;
    text-align: center;
    font-size: 24px;
    margin-top: 20px;
`;

// PageWrapper component
export const PageWrapper = styled.div`
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
`;

// ListContainer component
export const ListContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 1px solid ${NEUTRAL_100};
    border-radius: 16px;
    padding: 16px 12px;
    background-color: white;
    gap: 8px;
    margin-top: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
`;

// Divider component
export const Divider = styled.div`
    height: 1px;
    width: 100%;
    background-color: ${NEUTRAL_100};
`;

// ContentContainer component
export const ContentContainer = styled.div`
    position: relative;
    top: -6vh;
    padding-left: 12px;
    padding-right: 12px;
    overflow-y: auto;
`;